// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1753750669978
      var cssReload = require("G:/HBuilderX.3.8.4.20230531/HBuilderX/plugins/uniapp-cli/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"/","locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  